import { Components } from '@mui/material/styles';

export const MuiTab: Components['MuiTab'] = {
  styleOverrides: {
    root: {
      textTransform: 'none',
      fontWeight: 500,
      minWidth: 'auto',
      padding: '12px 16px',
    },
  },
};

export const MuiTabs: Components['MuiTabs'] = {
  styleOverrides: {
    indicator: {
      height: '3px',
      borderRadius: '3px 3px 0 0',
    },
  },
};
